import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreTranslationService } from '@core/services/translation.service';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { UserService } from 'app/auth/service';

import { DatePipe } from '@angular/common';
import moment from 'moment';

import { locale as en } from '../../i18n/en';
import { locale as fr } from '../../i18n/fr';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit {

  // Private
  private _unsubscribeAll: Subject<any>;

  public date_now: any;

  @Input() referencial;
  public activated = true;

  /**
   * Constructor
   *
   * @param {CoreTranslationService} _coreTranslationService
   * @param {UserService} _userService
   * @param {DatePipe} datepipe
   */
  constructor(
    private _coreTranslationService: CoreTranslationService,
    public datepipe: DatePipe
  ) {
    this._coreTranslationService.translate(en, fr);

    this._unsubscribeAll = new Subject();
  }

  public numberOfDaysUntilNow(date: string): number {
    const today = new Date();
    const missionDate = new Date(date);

    return Math.round((today.getTime() - missionDate.getTime()) / (1000 * 3600 * 24));
  }

  public onSelectEvent(event: any): void {
    console.log('dashboard ', event);
    this.referencial = event;
    // this.activated = event.survey_complete;
    localStorage.setItem('wave_target_uuid', event.wave_target_uuid);
  }


  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
  ngOnInit(): void {
    // Get oups, to_do and future missions, parse these
    this.date_now = this.datepipe.transform(new Date(), 'yyyy-MM-dd');

  }

  /**
  * On destroy
  */
   ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
